import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/tour";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-vine bg-moss/60">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 py-16 md:grid-cols-3 lg:px-10">
      <div>
        <div className="flex items-center gap-3">
          <img src="/trekpanda-mascot.png" alt="TrekPanda panda" className="h-10 w-auto" data-testid="footer-brand-logo" />
          <p className="font-sans text-lg font-extrabold tracking-[0.25em] text-cream">
            TREK<span className="text-marigold">PANDA</span>
          </p>
        </div>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-sage">
          Pocket-friendly group trips and treks across India. This one goes south — Kerala with
          Kanyakumari, 7 days, ex-Pune &amp; Mumbai.
        </p>
      </div>
      <div>
        <p className="text-[11px] uppercase tracking-[0.3em] text-sage">Explore</p>
        <ul className="mt-5 space-y-3 text-sm text-cream/80">
          <li><a href="#pricing" data-testid="footer-link-pricing" className="transition-colors duration-300 hover:text-marigold">Packages &amp; Pricing</a></li>
          <li><a href="#inclusions" data-testid="footer-link-inclusions" className="transition-colors duration-300 hover:text-marigold">Inclusions</a></li>
          <li><a href="#book" data-testid="footer-link-book" className="transition-colors duration-300 hover:text-marigold">Reserve a Seat</a></li>
        </ul>
      </div>
      <div>
        <p className="text-[11px] uppercase tracking-[0.3em] text-sage">Talk to Us</p>
        <a
          href={WHATSAPP_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="mt-5 inline-flex items-center gap-3 border border-marigold px-5 py-3 text-xs font-bold uppercase tracking-[0.25em] text-marigold transition-colors duration-300 hover:bg-marigold hover:text-jungle"
        >
          <MessageCircle size={14} /> 95297 17726
        </a>
        <p className="mt-5 text-sm text-sage">Departures from Pune, Mumbai &amp; Kochi</p>
      </div>
    </div>
    <div className="border-t border-vine">
      <p className="mx-auto max-w-7xl px-6 py-6 text-[11px] uppercase tracking-[0.2em] text-sage/60 lg:px-10">
        © 2026 TrekPanda · Kerala with Kanyakumari · Prices subject to availability
      </p>
    </div>
  </footer>
);
